import { CSSProperties } from 'styled-components'
import React from 'react'
import { Icon, Popup, PopupProps } from 'semantic-ui-react'
import { useFormContext } from 'react-hook-form'

interface Props {
  style?: CSSProperties
  name: string
  control: any;
  errorMessage?: string
}

function getNestedError(errors: any, name: string) {
  return name.split('.').reduce((acc, key) => acc?.[key], errors)
}

const ErrorIcon:React.FC<Props & PopupProps> = (props) => {
  const { style, name, errorMessage, ...popupProps } = props
  const { formState: { errors } } = useFormContext()

  const fieldError = getNestedError(errors, name)
  const message = fieldError?.message || errorMessage

  if(message) {
    return <Popup
      {...popupProps}
      key={name}
      content={message}
      trigger={<Icon name='warning sign' color='red' style={{ fontSize: '1.2em', ...style }} />}
  />
  }
}
export default ErrorIcon